import { cleanObject } from "../../../helpers";
import primaryComponents from "../../primaryComponents";
import { useReverseOrder } from "../../../hooks/api/mutations/useOrder";
import globalStyles from "../../../assets/styles/base/globalPage.module.scss";

const OrderCancel = ({ orderDetails, closeWidget }) => {
  const { cancelOrder, isLoading: isCancelling } = useReverseOrder();
  const cancelCurrentOrder = () => {
    cancelOrder({
      data: cleanObject({ orderId: orderDetails?.id }),
      onSuccess: () => {
        closeWidget();
      },
    });
  };

  return (
    <div className="py-3 px-3">
      <h4 className="text-center font-weight-semibold">
        Are you sure you want to cancel this bill
      </h4>
      <div className={globalStyles.cardWithBackground}>
        <p className="dark--text mb-1 normal-text-size">Order Number</p>
        <p>{orderDetails?.id}</p>
      </div>

      <div
        className="d-flex justify-content-between mt-2"
        style={{ gap: "15px" }}
      >
        <primaryComponents.Button
          onClick={() => {
            closeWidget();
          }}
          classNames={"btn btn--outline cover"}
        >
          Cancel
        </primaryComponents.Button>
        <primaryComponents.Button
          onClick={() => {
            cancelCurrentOrder();
          }}
          classNames={"btn btn--danger cover"}
          loadingText={"Cancelling..."}
          isLoading={isCancelling}
          isDisabled={isCancelling}
        >
          Continue
        </primaryComponents.Button>
      </div>
    </div>
  );
};
export default OrderCancel;
